import { useEffect, useState, useContext } from "react";
import { baseUrl } from "../../connections";
import { UserContext } from "../../context/UserContext";

export const useLandmark = () => {
  const { userDetails } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState(null);
  const [payloads, setlandmarkPayloads] = useState('');
  const [page, setpage] = useState(0);
  const [countryid, setcountryid] = useState('');
  const [cityid, setcityid] = useState('');

//   cityid

  const [countyid, setcountyid] = useState('');

//   countyid
  const [stateid, setstateid] = useState('');

//   stateid
  const [limit, setlimit] = useState(10);
  const [search, setsearch] = useState(null);
  const [stateChange, setStateChange] = useState(false)
  const [count ,setcount ] = useState(10)

  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("x-auth-token", userDetails?.token);
  useEffect(() => {
    if(payloads) {
    setIsLoading(true);
      const params = JSON.stringify(payloads);
      const requestOptions = {
        method: "GET",
        headers: headers,
        redirect: "follow",
      };
    //   /pincode/housing/communities/list?country_uuid=CO-42A82D09&state_uuid=ST-D8830887&county_uuid=CNTY-2C7F097B&city_uuid=CITY-DF2C30CF&pincode=55442%27
      fetch(`${baseUrl}/pincode/housing/communities/list?${payloads}`, requestOptions)
        .then(async (response) => {
          const res = await response.text();
          if (response.status !== 200) {
            throw res;
          }
          return JSON.parse(res);
        })
        .then((result) =>{
          setData(result);
          setError(false);
          setcount(result?.count);
          setIsLoading(false);
        })
        .catch((err) => {
          setError(err);
          setIsLoading(false);
        });
      }
  }, [stateChange, payloads, page, limit, search]);

  return {
    housingcommunity: data,
    isLoading,
    error,
    setlandmarkPayloads,
    page,
    limit
  };
};
